<breadcrumb-layout>
	<li>
		<breadcrumb-item-view (action)="goToArchive()">
			{{ 'common_archive' | translate }}
		</breadcrumb-item-view>
	</li>
</breadcrumb-layout>
